@let control = $control();
<unity-control-wrapper displayName="Recurrence" description="Create a scheduling rule" [control]="control" [showHint]="false">
  <kendo-recurrence-editor #recurrenceEditor class="recurrence-editor" [formControl]="control" (click)="onRecurrenceEvent($event)" />
</unity-control-wrapper>
